import { timeLimitedApiPost } from './fetch';
import { DeviceId, StreamIndex, UtcTime } from 'types';
import { baseUrl } from './baseUrl';


type LocalIceCandidatesRequest = {
    deviceId: DeviceId;
    peerId: string;
    candidates: string;
};

export const postLocalIceCandidates = async (deviceId: DeviceId, peerId: string, candidates: RTCIceCandidate[]) =>
    await timeLimitedApiPost<LocalIceCandidatesRequest>(`${baseUrl}/webrtc/ice-local`, { deviceId, peerId, candidates: JSON.stringify(candidates) })
;

type RemoteIceCandidatesRequest = {
    deviceId: DeviceId;
    peerId: string;
};

export const postRemoteIceCandidates = async (deviceId: DeviceId, peerId: string) =>
    await timeLimitedApiPost<RemoteIceCandidatesRequest, string>(`${baseUrl}/webrtc/ice-remote`, { deviceId, peerId })
;

export type IceServer = {
    type: 'stun' | 'turn';
    url: string;
    username: string;
    password: string;
};

type ConnectStreamRequest = {
    deviceId: DeviceId;
    streamIndex: StreamIndex;
    utcTime: UtcTime;
};

type ConnectStreamResponse = {
    deviceId: DeviceId;
    peerId: string;
    utcTime: UtcTime;
    offer: string;
    iceServers: ReadonlyArray<IceServer>;
};

export const postConnectRequest = async (deviceId: DeviceId, streamIndex: StreamIndex, utcTime: UtcTime) =>
    await timeLimitedApiPost<ConnectStreamRequest, ConnectStreamResponse>(`${baseUrl}/webrtc/connect`, { deviceId, streamIndex, utcTime })
;

type AnswerStreamRequest = {
    deviceId: DeviceId;
    peerId: string;
    answer: string;
};

export const postAnswerRequest = async (deviceId: DeviceId, peerId: string, answer: string) =>
    await timeLimitedApiPost<AnswerStreamRequest>(`${baseUrl}/webrtc/answer`, { deviceId, peerId, answer })
;

type DisconnectStreamRequest = {
    deviceId: DeviceId;
    peerId: string;
};

export const postDisconnectRequest = async (deviceId: DeviceId, peerId: string) =>
    await timeLimitedApiPost<DisconnectStreamRequest>(`${baseUrl}/webrtc/disconnect`, { deviceId, peerId })
;



// WEBPACK FOOTER //
// ./src/api/webrtc.ts